import { AbstractService } from "./AbstractService.js";
import { useScheduler } from "../utils/scheduler.js";
import { isFunction } from "../utils/is.js";
class RafService extends AbstractService {
  isTicking = false;
  scheduler = useScheduler(["update", "render"]);
  props = {
    time: performance.now()
  };
  trigger(props) {
    for (const callback of this.callbacks.values()) {
      this.scheduler.update(() => {
        const render = callback(props);
        if (isFunction(render)) {
          this.scheduler.render(() => {
            render(props);
          });
        }
      });
    }
  }
  loop() {
    this.props.time = performance.now();
    this.trigger(this.props);
    if (!this.isTicking) {
      return;
    }
    requestAnimationFrame(() => this.loop());
  }
  init() {
    this.isTicking = true;
    requestAnimationFrame(() => this.loop());
  }
  kill() {
    this.isTicking = false;
  }
}
function useRaf() {
  return RafService.getInstance();
}
export {
  RafService,
  useRaf
};
//# sourceMappingURL=RafService.js.map
